import { Recurrence } from '@tableau/self-service-schedules';
import { Action } from 'redux';

import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import { SchedulingErrorCode } from '~src/commonInfra/utils/ErrorCodes';
import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { CreateExtractRefresh } from '../../../bootstrap/redux/actions/AppActionTypes';
import { Messages } from '../../../codegen/Localize';
import { SetExtractTasksSelfServiceScheduleRequest } from '../../../extractTask/serverApi/requests/SetExtractTasksSelfServiceScheduleRequest';
import { IError } from '../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../../httpClient/WebHttpClient';
import { RefreshTaskType } from '../../../schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { SelfServiceSchedule } from '../../../schedule/serverApi/types/SelfServiceSchedule';

export interface CreateExtractRefreshAction extends Action {
  selectedContent: IContentInfo[];
  mode: CreateExtractTasksMode;
}

export namespace CreateExtractRefreshAction {
  export function sendCreateExtractRequest(recurrence: Recurrence, taskType: RefreshTaskType, scheduleName: string, ids: number[]): Promise<IResult> {
    const request = new SetExtractTasksSelfServiceScheduleRequest({
      schedule: SelfServiceSchedule.fromRecurrence(recurrence, 'Extract'),
      type: taskType,
      scheduleName: scheduleName.substring(0, 255),
      ids,
    });
    return new Promise<IResult>((resolve, reject) => {
      WebHttpClient.sendRequest(request).then(result => {
        CreateExtractRefreshAction.notifyResult(result, false);
        resolve(result);
      }).catch(err => {
        CreateExtractRefreshAction.notifyResult();
        reject(err);
      });
    });
  }

  function errorCodeToMessage(error: IError): string {
    switch (error.code) {
      case SchedulingErrorCode.SchedulingNotAllowedInPersonalSpace:
        return Messages.extractTasksRefreshNotAllowedInPersonalSpaceForWorkbook();
      default:
        return Messages.refreshSelfServiceScheduleUnexpectedError({ ERROR_CODE: String(error.code) });
    }
  }

  export function notifyResult(result?: IResult, isNew?: boolean) {
    if (result && result.errors && result.errors.length) {
      const errorMessage = errorCodeToMessage(result.errors[0]);
      ContentActionNotification.displayFailureToast(errorMessage);
    } else {
      const toastContent = isNew
        ? Messages.refreshSelfServiceScheduleCreateSuccess()
        : Messages.refreshSelfServiceScheduleChangeSuccess();
      ContentActionNotification.displaySuccessToast(toastContent);
    }
  }
}

export function createExtractRefresh(
  selectedContent: IContentInfo[],
  mode: CreateExtractTasksMode
): CreateExtractRefreshAction {
  return {
    type: CreateExtractRefresh,
    selectedContent,
    mode,
  };
}
